/**
 * @public
 */
function getCallbackName(ui) {
    if (ui.adapterMismatchBehavior === 'disabled') {
        return 'shouldDisabled';
    }
    return 'shouldHide';
}

export { getCallbackName };
//# sourceMappingURL=schematic-ui-settings.js.map
